// store/filtersSlice.jsx
import { createSlice } from '@reduxjs/toolkit';

const nVal = null;
export const initialState = {
    customers: '',
    affiliateUsers: '',
    ordersStatus: ["COMPLETED"],
    providerNames: [],
    promoCodes: '',
    paymentGateways: [],
    purchaseDates: nVal,
    purchaseDatesFrom: nVal,
    purchaseDatesTo: nVal,
    filterCounts: 1,
    keywordsSearch: "",
    simType: ""
};

const orderFilters = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setCustomers: (state, action) => { state.customers = action.payload; },
        setAffiliateUsers: (state, action) => { state.affiliateUsers = action.payload; },
        setOrdersStatus: (state, action) => { state.ordersStatus = action.payload; },
        setProviderNames: (state, action) => { state.providerNames = action.payload; },
        setPromoCodes: (state, action) => { state.promoCodes = action.payload; },
        setPaymentGateways: (state, action) => { state.paymentGateways = action.payload; },
        setPurchaseDates: (state, action) => { state.purchaseDates = action.payload; },
        setPurchaseDatesFrom: (state, action) => { state.purchaseDatesFrom = action.payload; },
        setPurchaseDatesTo: (state, action) => { state.purchaseDatesTo = action.payload; },
        setFilterCounts: (state, action) => { state.filterCounts = action.payload; },
        setKeywordsSearch: (state, action) => { state.keywordsSearch = action.payload; },
        setSimType: (state, action) => { state.simType = action.payload; },
        resetFilters: () => initialState,
    },
});

export const {
    setCustomers,
    setAffiliateUsers,
    setOrdersStatus,
    setProviderNames,
    setPromoCodes,
    setPaymentGateways,
    setPurchaseDates,
    setPurchaseDatesFrom,
    setPurchaseDatesTo,
    setFilterCounts,
    setKeywordsSearch,
    setSimType,
    resetFilters,
} = orderFilters.actions;

export default orderFilters.reducer;
